<template>
  <div class="package-toggle bg-lightblur bg-glass-darkmode font-h6">
    <div class="item" :class="{ active: value == 'yearly' }" @click="$emit('input', 'yearly')">
      <span>Yearly</span>
      <span class="discount ml-5">-20%</span>
    </div>
    <div class="item" :class="{ active: value == 'monthly' }" @click="$emit('input', 'monthly')">
      <span>Monthly</span>
    </div>
  </div>
</template>

<script>
export default {
  name: "Toggle",
  components: {},
  props: {
    value: String,
  },
  data: function () {
    return {};
  },
  computed: {},
  async mounted() {},
  methods: {},
};
</script>
